export enum SnackbarType {
  Success = 'success',
  Information = 'information',
  Error = 'error',
}
